import { render, staticRenderFns } from "./EditCommentBtn.vue?vue&type=template&id=4c7a31a6&"
import script from "./EditCommentBtn.vue?vue&type=script&lang=js&"
export * from "./EditCommentBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports